import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardMessage,
	CardTitle
} from "src/common/components/Card";
import { FullCardPreloader } from "src/common/components/Preloader";
import { Permission, useHasPermission } from "src/features/auth";
import { PatientLink, usePatientIdParam } from "src/features/patient";
import { node as committeeOpinionForm } from "src/modules/ktx/forms/committeeOpinion";
import { StatusHistoryTimeline } from "src/modules/ktx/status-history/StatusHistoryTimeline";
import { usePatientConditionEvents } from "src/modules/ktx/status-history/usePatientConditionEvents";
import { usePatientConditionTimelineItems } from "src/modules/ktx/status-history/usePatientConditionTimelineItems";

const messages = defineMessages({
	title: {
		id: "ktx.status_history.title",
		defaultMessage: "Állapotváltozás áttekintő"
	},
	status: {
		id: "ktx.status_history.status",
		defaultMessage: "Státusz"
	},
	noChanges: {
		id: "ktx.status_history.no_changes",
		defaultMessage: "Nincsenek állapotváltozások"
	},
	newChange: {
		id: "ktx.status_history.new_change",
		defaultMessage: "Új állapotváltozás"
	}
});

export const StatusHistory: React.FunctionComponent = () => {
	const patientId = usePatientIdParam();
	const hasLimitedAccessPermission = useHasPermission(
		Permission.LimitedAccessFormRW
	);
	const { isLoading, events } = usePatientConditionEvents(patientId);
	const items = usePatientConditionTimelineItems(events);
	return (
		<Card>
			<CardHeader>
				<CardTitle>
					<FormattedMessage {...messages.title} />
				</CardTitle>
			</CardHeader>
			<CardContent>
				{isLoading ? (
					<FullCardPreloader />
				) : items.length === 0 ? (
					<CardMessage>
						<FormattedMessage {...messages.noChanges} />
					</CardMessage>
				) : (
					<StatusHistoryTimeline items={items} />
				)}
			</CardContent>
			<CardFooter>
				{hasLimitedAccessPermission && (
					<PatientLink
						to={`/form/${committeeOpinionForm.id}`}
						className="button button--primary"
					>
						<FormattedMessage {...messages.newChange} />
					</PatientLink>
				)}
			</CardFooter>
		</Card>
	);
};
